import { render, staticRenderFns } from "./stock.vue?vue&type=template&id=d1a032e2&scoped=true&"
import script from "./stock.vue?vue&type=script&lang=js&"
export * from "./stock.vue?vue&type=script&lang=js&"
import style0 from "./stock.vue?vue&type=style&index=0&id=d1a032e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a032e2",
  null
  
)

export default component.exports